export const heroStats = [
  { value: "40+", label: "Matching Variables" },
  { value: "3", label: "Core Dimensions" },
  { value: "98%", label: "Match Success" },
] as const;

export const journeySteps = [
  {
    title: "Discover",
    description: "Explore inspiration & ideas",
    icon: "search",
  },
  {
    title: "Learn",
    description: "Gain confidence through education",
    icon: "cap",
  },
  {
    title: "Profile",
    description: "Take our personality quiz",
    icon: "id",
  },
  {
    title: "Match",
    description: "Get paired with designers",
    icon: "hearts",
  },
  {
    title: "Connect",
    description: "Start the collaboration",
    icon: "chat",
  },
] as const;

export const pillars = [
  {
    title: "Personality First",
    priorityLabel: "Personality",
    description:
      "We start where it matters most - the relationship. The ColorWorks Group assessment ensures you click from day one.",
    icon: "fingerprint",
    linkText: "See Variable Examples",
    homeownerQuestions: [
      "Policies should be...",
      "When I make decisions I...",
      "Between these two things I am most stressed by...",
      "When I am frustrated, most often I need...",
    ],
    designerQuestions: [
      "Policies should be...",
      "When I make decisions I...",
      "Between these two things I am most stressed by...",
      "When I am frustrated, most often I need...",
    ],
  },
  {
    title: "Your Preferences",
    priorityLabel: "Preferences",
    description:
      "From whether you are a dog or cat person to age, sex, or even if you also want to match for lifestyle - we tailor to what makes you you.",
    icon: "heart",
    linkText: "See Variable Examples",
    homeownerQuestions: [
      "What traits does your ideal designer have?",
      "Personal Preferences: gender, pet-friendly, LGBTQ-friendly, political affiliation, same age, minority-owned business...",
      "Do you prefer to work with an interior designer who has children?",
      "How many years of experience would you like your interior designer to have?",
    ],
    designerQuestions: [
      "Rank your strengths, highest to lowest.",
      "Please answer the following....",
      "Do you have children?",
      "Tell us about your interior design work history.",
    ],
  },
  {
    title: "Project Details",
    priorityLabel: "Project",
    description:
      "Budget, timeline, style goals, billing preferences, square footage - we match on all the variables to find your perfect fit.",
    icon: "clipboard",
    linkText: "See Variable Examples",
    homeownerQuestions: [
      "Tell us about your budget range.",
      "Which of the following best describes your project?",
      "Any special needs or considerations for this project?",
      "Take the Design Style Quiz",
    ],
    designerQuestions: [
      "Minimum budget range you are comfortable working with.",
      "Please rank your design competency for the following project types.",
      "Please rank your competency in each specialty design area.",
      "Please rank your competency in the following design styles.",
    ],
  },
] as const;

export const matchingData = {
  homeowner: {
    label: "Homeowner",
    personalityType: "Extrovert Blue Gold",
    answers: [
      {
        section: "Personality",
        question: "ColorWorks Quiz",
        answer: "Extrovert Blue Gold",
        liked: true,
      },
      {
        section: "Billing",
        question: "Billing preference for design project",
        answer: "Flat fee",
        liked: false,
      },
      {
        section: "Partnership",
        question: "Preferred partnership style",
        answer: "Collaborative",
        liked: false,
      },
      {
        section: "Preference",
        question: "Designer years of expertise",
        answer: "10+ years",
        liked: false,
      },
    ],
  },
  designer: {
    label: "Interior Designer",
    personalityType: "Extrovert Blue Orange",
    answers: [
      {
        section: "Personality",
        question: "ColorWorks Quiz",
        answer: "Extrovert Blue Orange",
        liked: true,
      },
      {
        section: "Billing",
        question: "How do you charge clients?",
        answer: "Flat fee",
        liked: false,
      },
      {
        section: "Partnership",
        question: "Preferred client partnership style",
        answer: "Collaborative",
        liked: false,
      },
      {
        section: "Preference",
        question: "Years of experience",
        answer: "18",
        liked: false,
      },
    ],
  },
} as const;

export const postMatchSteps = [
  {
    title: "Swipe & Love",
    description: "Review matches. Save designers that resonate.",
    icon: "arrow",
  },
  {
    title: "Chat & Share",
    description: "Message favorites. Share mood boards and ideas.",
    icon: "message",
  },
  {
    title: "Connect",
    description: "Schedule video calls. Feel the chemistry.",
    icon: "video",
  },
  {
    title: "Begin",
    description: "Choose your designer and start creating.",
    icon: "spark",
  },
] as const;

export const midCta = {
  title: "Ready To Find Your Perfect Match?",
  subtitle:
    "Whether you're looking for someone to challenge your creative boundaries, fully realize your bold ideas, or handle everything from start to finish, we have you covered.",
} as const;

export const finalCta = {
  title: "Ready To Find Your Perfect Match?",
  subtitle:
    "Join thousands of homeowners who found their ideal designer through our relationship-first matching process.",
} as const;

export const personalityQuiz = {
  label: "Powered by ColorWorks Group",
  title: "Discover Your Working Personality",
  subtitle:
    "The ColorWorks Group personality assessment reveals how you collaborate, communicate, and make decisions - ensuring we match you with interior designers who complement your style.",
  question: "When I Make Decisions I...",
  optionA: "Logically analyze all perspectives including my feelings.",
  optionB: "Trust my gut feelings, see if it's logical.",
  cta: "Take the Quiz - It's Free",
} as const;

export const testimonials = {
  quote:
    "My interior designer and I clicked immediately - we communicate the same way and share the same vision. It made the entire process a joy.",
  name: "Shae",
  location: "Atlanta, GA",
  helperText: "See what other homeowners & designers have to say.",
  videos: [
    {
      id: "1171649639",
      title: "Making the Match: We Love Pink!",
      thumbnail:
        "https://i.vimeocdn.com/video/2131219530-f43ca86bca25c6fa2e9a6f028cfd10b7ff02400b3879c151bc413e9ee850c0ea-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171649639",
    },
    {
      id: "1171649043",
      title: "Making the Match: A True Investment",
      thumbnail:
        "https://i.vimeocdn.com/video/2131218234-b34977fbad9fec813aef558af4aea3e471d91824b77bceaba949ad18f8c342d3-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171649043",
    },
    {
      id: "1171648152",
      title:
        "Making the Match: The #1 Thing to Look For When Hiring an Interior Designer",
      thumbnail:
        "https://i.vimeocdn.com/video/2131217351-57f7d85300cc395f8272a6b112e6e5b101a3dd1a03888eb754a7ee6c447fa910-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171648152",
    },
    {
      id: "1171646811",
      title: "Making the Match: Design is a Gift",
      thumbnail:
        "https://i.vimeocdn.com/video/2131216152-88e8f27e265ae589135ed8cc9c6144f476de7ee43391f3b72c85350d4675b2a4-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171646811",
    },
    {
      id: "1171646029",
      title:
        "Making the Match: The Best Thing About Hiring an Interior Designer",
      thumbnail:
        "https://i.vimeocdn.com/video/2131214609-2b0ca6db34ede7b37432f659e22179f6d5aaf413cca514c890a4a9fc1cc28667-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171646029",
    },
    {
      id: "1171645140",
      title: "Making the Match: Changed our Life",
      thumbnail:
        "https://i.vimeocdn.com/video/2131213563-cb19a98ae68a258804233cc7a7ecfb54943382b22d897be61ccadafdb31216cb-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171645140",
    },
    {
      id: "1171644267",
      title:
        "Making the Match: The Greatest Thing My Designer Talked Me Into",
      thumbnail:
        "https://i.vimeocdn.com/video/2131212461-b47e7735f1cd2a5c0511ffcc343ddce76c484a15bfd24bd60e98934e6b7d3d47-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171644267",
    },
    {
      id: "1171643048",
      title: "Making the Match: Ingenious Way to Find a Designer",
      thumbnail:
        "https://i.vimeocdn.com/video/2131210702-03ffc0075cdf3011314ec8e58731b4545c560a467c731c815eaba5c4f6888cb7-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171643048",
    },
    {
      id: "1171630230",
      title: "Making the Match: Excited for the Journey",
      thumbnail:
        "https://i.vimeocdn.com/video/2131211249-1b1f1a9f46362b754ade9010bc625abd777b1ad19b8c4543c4cdba51fbb01147-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171630230",
    },
    {
      id: "1171642198",
      title: "Making the Match: The Secret to a Great Relationship",
      thumbnail:
        "https://i.vimeocdn.com/video/2131209394-fcb28eac5b3e789129123b99b87bed0e26d49258d16ff6ff68e84c2115d74a62-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171642198",
    },
    {
      id: "1171641465",
      title: "Making the Match: It's all About the Relationship",
      thumbnail:
        "https://i.vimeocdn.com/video/2131208103-a6d8d541ee4f6e649a46a9b4ba9a825c3cf4b03d8acf487e26ce828d046a870d-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171641465",
    },
    {
      id: "1171640847",
      title: "Making the Match: Compatibility (Copy)",
      thumbnail:
        "https://i.vimeocdn.com/video/2131207220-1f4c2cf24513a878c157786aa3df1a51f04c415cff37e4eaeeb83b5cadf1ca62-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171640847",
    },
    {
      id: "1171639824",
      title: "Making the Match: Quality Vetted Designers",
      thumbnail:
        "https://i.vimeocdn.com/video/2131206448-9a41a23787fe005612b220a9cdf05280f9bd44f1c1da5cced0a19413ebc6e288-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171639824",
    },
    {
      id: "1171635399",
      title: "Making the Match: Finding the One",
      thumbnail:
        "https://i.vimeocdn.com/video/2131203745-abdc288db608cbc430824aabb1c305684ddd19e3485a3f758e49812e598f4bb3-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171635399",
    },
    {
      id: "1171638416",
      title: "Making the Match: Taking out the Guesswork",
      thumbnail:
        "https://i.vimeocdn.com/video/2131205016-38037b0c09593a6cfe724861a1db0dc469225570cd457e059b8b9dd66643e6a9-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171638416",
    },
    {
      id: "1171633818",
      title: "Making the Match: Compatibility",
      thumbnail:
        "https://i.vimeocdn.com/video/2131199809-ba9f49d510f82633d3e5627513e825d7388ace4b02db589202064acff0068ab1-d_640?region=us",
      url: "https://vimeo.com/reviews/bf8abbd5-caec-4b5e-93cb-2807e252d023/videos/1171633818",
    },
  ],
} as const;

export type JourneyStep = (typeof journeySteps)[number];
export type Pillar = (typeof pillars)[number];
